/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:48 GMT
 *
 */

import PaletteIconArrowRight from '@telus-uds/palette-allium/build/rn/icons/ArrowRight'
import PaletteIconPause from '@telus-uds/palette-allium/build/rn/icons/Pause'
import PaletteIconPlayVideo from '@telus-uds/palette-allium/build/rn/icons/PlayVideo'
import PaletteIconArrowLeft from '@telus-uds/palette-allium/build/rn/icons/ArrowLeft'
const theme = {
  appearances: {
    viewport: {
      description: 'The size label for the current screen viewport based on the current screen width',
      type: 'state',
      values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
    }
  },
  rules: [
    {
      if: { viewport: [ 'xs', 'sm' ] },
      tokens: { showPanelTabs: false, showPreviousNextNavigation: false }
    }
  ],
  tokens: {
    backgroundColor: 'rgba(0, 0, 0, 0)',
    iconBackgroundColor: '#ffffff',
    nextIcon: PaletteIconArrowRight,
    pauseIcon: PaletteIconPause,
    playIcon: PaletteIconPlayVideo,
    previousIcon: PaletteIconArrowLeft,
    showPanelNavigation: true,
    showPanelTabs: true,
    showPreviousNextNavigation: true,
    spaceBetweenSlideAndPanelNavigation: 32,
    spaceBetweenSlideAndPreviousNextNavigation: 24,
    stepTrackerCurrentBackgroundColor: null
  }
}
export default theme
